import type { IResultUrlNormalizedParameters } from '@eureka/services/src/types/results';

export enum EBatchSaveType {
    PATENT = 'patent',
    PAPER = 'paper'
}
export interface IBatchSaveProps {
    solutionIds?: string[],
    total?: number,
}

export interface IServiceProps extends IBatchSaveProps {
    conditions?: IResultUrlNormalizedParameters,
    type?: EBatchSaveType,
}
